import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfilePaymentsRequest } from '@/shared/api/requests/club/payments/get/request';
import { getClubProfilePayments } from '@/shared/api/requests/club/payments/get/request';

export const useClubProfilePaymentsQuery = (
  params: GetClubProfilePaymentsRequest,
  settings?: QuerySettings<typeof getClubProfilePayments>
) =>
  useQuery({
    queryKey: ['ClubProfilePayments', params.clubId],
    queryFn: () =>
      getClubProfilePayments({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
